interface BrandLogoProps {
  src: string;
  alt: string;
  variant?: 'standard' | 'full';
  onClick?: () => void;
}

export const BrandLogo = ({
  src,
  alt,
  variant = 'standard',
  onClick,
}: BrandLogoProps) => (
  <div
    className="flex aspect-square size-full cursor-pointer items-center justify-center rounded-8 bg-neutral-200 p-2 hover:bg-neutral-100"
    onClick={onClick}
  >
    <img
      src={src}
      alt={alt}
      {...(variant === 'standard' && { width: 57, height: 57 })}
      className={`object-contain ${
        variant === 'full' ? 'max-h-16 max-w-full' : ''
      }`}
    />
  </div>
);
